import React from 'react';
import CheckboxFilter from './CoreComponents/CheckboxFilter';

const CheckboxFilterByType = (props) => {
    const { searchTypes, searchTypesPropName, filterInputs, filtersPropName, onChange, 'data-testid': dataTestId } = props;
    const options = searchTypes && searchTypes[searchTypesPropName] ? searchTypes[searchTypesPropName] : [];

    return (
        <CheckboxFilter
            options={options}
            filterInputs={filterInputs}
            filterInputName={filtersPropName}
            onChange={onChange}
            data-testid={dataTestId}
        />
    );
};

export default CheckboxFilterByType;
